// extracted by mini-css-extract-plugin
module.exports = {"on_scroll_view":"kelQwM"};